<script setup lang="ts">
import axios from "axios";
import { useSearch } from "./utils";
import { ref, watch } from "vue";
import CommandInput from "../command/CommandInput.vue";
import { CommandItem, CommandList } from "../command";
import { router } from "@inertiajs/vue3";
import { debounce, throttle } from "lodash";

const { open, toggleSearch } = useSearch();

const term = ref("");
const results = ref({
  customers: [],
  leads: [],
});
const selectedItem = ref(null);

watch(
  () => open.value,
  () => {
    setTimeout(() => {
      if (open.value) {
        document.getElementById("search").focus();
      } else {
        document.getElementById("search").blur();
      }
    }, 100);
  }
);

watch(
  term,
  debounce(() => {
    axios.get(route("api.customers.index"), { params: { search: term.value } }).then((response) => {
      results.value.customers = response.data.data;
    });
    axios.get(route("api.leads.index"), { params: { search: term.value } }).then((response) => {
      results.value.leads = response.data.data;
    });
  }, 500)
);
</script>

<template>
  <div
    v-show="open"
    class="fixed inset-0 flex items-start pt-[14vh] z-40"
  >
    <div
      @click="toggleSearch"
      class="fixed inset-0 bg-black/20"
    ></div>
    <div class="relative flex flex-col items-start mt-10 px-2 rounded-lg border shadow-md mx-auto max-w-[600px] max-h-[450px] w-full bg-white">
      <Command v-model:searchTerm="term" :filterFunction="(val) => val">
        <div class="w-full border-b px-2">
          <CommandInput
            id="search"
            placeholder="Cerca..."
            class="appearance-none block w-full h-10 rounded-lg focus:outline-hidden"
            autocomplete="off"
          />
        </div>
        <CommandEmpty>
          Nessun elemento trovato.
          <div class="text-sm text-gray-500">Prova a modificare la ricerca.</div>
        </CommandEmpty>
        <CommandList>
          <CommandGroup heading="Customers">
            <CommandItem
              v-for="result in results.customers"
              :key="result.id"
              :value="result.id"
              class="flex items-center justify-between w-full px-2 py-1"
              @select="
                () =>
                  router.visit(route('admin.customers.show', { customer: result.id }), {
                    onSuccess: () => {
                      selectedItem = result;
                      toggleSearch();
                    },
                  })
              "
            >
              <span>{{ result.name }}</span>
              <span>{{ result.email }}</span>
            </CommandItem>
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Leads">
            <CommandItem
              v-for="result in results.leads"
              :key="result.uuid"
              :value="result.uuid"
              class="flex items-center justify-between w-full px-2 py-1"
              @select="
                () =>
                  router.visit(route('admin.leads.show', { lead: result.id }), {
                    onSuccess: () => {
                      selectedItem = result;
                      toggleSearch();
                    },
                  })
              "
            >
              <span>{{ result.type }} {{ result.customer.name }}</span>
              <span>{{ result.email }}</span>
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </Command>
    </div>
  </div>
</template>
